import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Logout, SelectCompany } from 'src/app/store/auth/auth.actions';
import { AuthState } from 'src/app/store/auth/auth.state';
import { ActivitySummarySetTimezone, SetDateType, SetDisplayedColumns, SetUserFilter } from './actions';
import { ActivitySummaryModel } from './model';


@State<ActivitySummaryModel>({
  name: 'activitySummary',
})
@Injectable()
export class ActivitySummaryState {
  @Selector()
  static displayedColumns(st: ActivitySummaryModel) {
    return st.displayedColumns;
  }

  @Selector([AuthState.userTimezone])
  static timezone(st: ActivitySummaryModel, userTimezone: string) {
    return st.timezone || userTimezone;
  }

  @Selector()
  static userFilter(st: ActivitySummaryModel) {
    return st.userFilter;
  }

  @Action(SetDisplayedColumns)
  setDisplayedColumns(ctx: StateContext<ActivitySummaryModel>, payload: SetDisplayedColumns) {
    ctx.patchState({ displayedColumns: payload.displayedColumns || [] });
  }

  @Action(SetDateType)
  setDateType(ctx: StateContext<ActivitySummaryModel>, payload: SetDateType) {
    ctx.patchState({ dateType: payload.dateType || null });
  }

  @Action(ActivitySummarySetTimezone)
  setTimezone(ctx: StateContext<ActivitySummaryModel>, { timezone }: ActivitySummarySetTimezone) {
    ctx.patchState({ timezone });
  }

  @Action(SetUserFilter)
  setUserFilter(ctx: StateContext<ActivitySummaryModel>, { userFilter }: SetUserFilter) {
    ctx.patchState({ userFilter });
  }

  /** Clear cross-account user selection persisted in the global NGXS storage key. */
  @Action([Logout, SelectCompany])
  resetUserFilter(ctx: StateContext<ActivitySummaryModel>) {
    ctx.patchState({ userFilter: undefined });
  }
}
